import { render } from "./JobStatusOptions.vue?vue&type=template&id=7a2d6632"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__